/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */

import { park } from '@/api/ajax';

export default [
  {
    width: 180,
    label: '个体名称',
    tip: '请输入个体名称',
    key: 'enterpriseName', // TODO：待确认字段
    id: 'enterpriseName', // TODO：待确认字段
    slot: 'input'
  },
  {
    width: 180,
    label: '经营者名称',
    tip: '请输入经营者名称',
    key: 'fullName', // TODO：待确认字段
    id: 'phone',
    slot: 'input'
  },
  {
    id: 'yuanqu',
    width: 180,
    tip: '请选择园区',
    key: 'openStatus',
    slot: 'select',
    clearable: false,
    options: []
  },
  {
    width: 180,
    label: '园区名称',
    tip: '园区',
    key: 'userEnterpriseParkCode',
    id: 'yuanquxialakuang',
    slot: 'ajaxSelect',
    clearable: false,
    isDisabled: true,
    // 获取 下拉数据 接口
    ajax: park.getOptions,
    prop: {
      label: 'userEnterpriseParkName',
      code: 'userEnterpriseParkCode'
    },
    ajaxQuery: 'userEnterpriseParkName'
  },
  {
    width: 180,
    label: '手机号',
    tip: '请输入手机号',
    key: 'phone',
    id: 'phone',
    slot: 'input'
  },
  {
    width: 180,
    label: '其他项目标签',
    tip: '请输入关键字',
    key: 'userTag',
    id: 'personLabel',
    slot: 'autocomplete',
    maxLength: 30,
    clearable: true,
    callback: function() {
      this.customQuery.notSet = this.customQuery.userTag === '未设置' ? 1 : 0;
    },
    querySearch: (queryString, cb) => {
      cb(
        [{ value: '未设置' }].filter(
          i => !queryString || i.value.indexOf(queryString) > -1
        )
      );
    }
  }
];
